import { render, staticRenderFns } from "./OrderInfoOverview.vue?vue&type=template&id=6198ac4c&"
import script from "./OrderInfoOverview.vue?vue&type=script&lang=js&"
export * from "./OrderInfoOverview.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports